import { IntegrationFeature } from "../../index";
import { OauthScope } from "./OauthScope";

type IntegrationFeatureOauthProps = {
	id: string;
	scopes: OauthScope[];
};

class IntegrationFeatureOauth extends IntegrationFeature {
	constructor(public _: IntegrationFeatureOauthProps) {
		super();
	}

	static fromJson(json: any): IntegrationFeatureOauth {
		return new IntegrationFeatureOauth({
			id: json.id,
			scopes: json.scopes.map((scope: any) => OauthScope.fromJson(scope)),
		});
	}

	static get type(): string {
		return "oauth";
	}

	get id(): string {
		return this._.id;
	}

	scopesByIds(ids: string[]): OauthScope[] {
		return this._.scopes.filter((scope) => ids.includes(scope._.id));
	}

	scopeById(id: string): OauthScope | undefined {
		return this._.scopes.find((scope) => scope._.id === id);
	}

	toJson() {
		return {
			id: this._.id,
			type: IntegrationFeatureOauth.type,
			scopes: this._.scopes.map((scope) => scope.toJson()),
		};
	}
}

export { IntegrationFeatureOauth };
